import React, { useEffect, useState, useContext } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import SearchAppScheduleReq from "../../../../Classes/Models/Requests/Appointments/SearchAppScheduleReq";
import Swal from "sweetalert2";
import AddTherapistToDay from "../../AppointmentDays/AppointmentDayDetails/AddTherapistToDay";
import AppDayTableSimple from "./AppDayTableSimple";
import { UserContext, LanguageContext, ConnectionContext } from "App";
import CopyDayCard from "./CopyDayCard";
import "./AppDay.scss";
import Loader from "layouts/loader/loader";
import { useLocation } from "react-router-dom";

const Index = () => {
  const User = useContext(UserContext);
  const { state, search } = useLocation();
  const { translations } = useContext(LanguageContext);

  const [IsLoaded, setIsLoaded] = useState(false);
  const [AppDay, setAppDay] = useState({});
  const [ShowCopyDay, setShowCopyDay] = useState(false);
  const [ShowAddTherapist, setShowAddTherapist] = useState(false);
  const [checkedDays, setCheckedDays] = useState([]);
  const [DayPartitionNumber, setDayPartitionNumber] = useState(2);

  const queryParams = new URLSearchParams(search);
  const slotFromUrl = queryParams.get("slot");
  const dayIdFromUrl = queryParams.get("dayId");

  useEffect(() => {
    if (slotFromUrl) {
      const slotNumber = parseInt(slotFromUrl);
      if (slotNumber !== DayPartitionNumber) {
        setDayPartitionNumber(slotNumber);
      }
    }
  }, [slotFromUrl]);

  useEffect(() => {
    let isMounted = true; 

    const fetchCurrentDay = async () => {
      const effectiveDayId = dayIdFromUrl || state?.AppDay?.id;

      if (effectiveDayId) {
        setIsLoaded(false);
        const res = await GetAppDayById(effectiveDayId, DayPartitionNumber);

        if (isMounted && res?.status === "Success") {
          setIsLoaded(true);
        }
      }
    };

    fetchCurrentDay();

    return () => {
      isMounted = false;
    }; 
  }, [dayIdFromUrl, state?.AppDay?.id, DayPartitionNumber]);

  const GetAppDayById = async (Id, HoursIndex) => {
    let req = new SearchAppScheduleReq();
    req.SearchInt = Id;
    req.HoursIndex = HoursIndex ?? DayPartitionNumber;

    try {
      let res = await AppointmentsApi.GetAppoinmentDayByIdIndexed(req);
      if (res.status === "Success") {
        setAppDay(res.data);
        return res;
      } else {
        Swal.fire("Failed", res.message, "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Failed", "An error occurred while fetching data", "error");
    }
  };

  if (!IsLoaded && Object.keys(AppDay).length === 0) {
    return <Loader />;
  }

  return (
    <div className="AppDayIndex">
      <AppDayTableSimple
        AppDay={AppDay}
        setAppDay={setAppDay}
        setIsLoaded={setIsLoaded}
        GetAppDayById={GetAppDayById}
        id={dayIdFromUrl || state?.AppDay?.id}
        DayPartitionNumber={DayPartitionNumber}
        setDayPartitionNumber={setDayPartitionNumber}
        IsLoaded={IsLoaded}
        setShowCopyDay={setShowCopyDay}
        ShowCopyDay={ShowCopyDay}
        setShowAddTherapist={setShowAddTherapist}
        ShowAddTherapist={ShowAddTherapist}
        checkedDays={checkedDays}
      />
    </div>
  );
};

export default Index;
